var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Heading } from "@riseart/common";
import { Row } from "@riseart/antd-provider";
import { footerSocialCls } from "./Footer.less";
var FooterSocial = /* @__PURE__ */ __name(function FooterSocial2(_ref) {
  var children = _ref.children, title = _ref.title;
  return /* @__PURE__ */ React.createElement("div", {
    className: footerSocialCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "p",
    level: "4"
  }, title), /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    align: "top",
    justify: "space-between"
  }, children));
}, "FooterSocial");
export {
  FooterSocial
};
